import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { Collapse } from 'reactstrap';
import { bindActionCreators } from 'redux';
import { Translate, withLocalize } from 'react-localize-redux';
import { popupActions } from '../../../store/popupStore';

class GeneralAssemblyItem extends React.Component {
    state = { expanded: false }

    render() {
        if (this.props.data === undefined || this.props.data === null)
            return null;

        return (
            <>
                <tr className="colorize">
                    <td style={{ textAlign: "right" }}>{this.props.data.dateFormatted}</td>
                    <td>{this.props.data.type}</td>
                    <td>{this.props.data.place}</td>
                    <td style={{ textAlign: "right" }}>{this.props.data.determinationDateFormatted}</td>
                    <td>{this.props.data.media}</td>
                    <td style={{ textAlign: "right" }}>{this.props.data.announcementDateFormatted}</td>
                    <td style={{ textAlign: "right" }}>
                        <div onClick={() => this.onDetailClick()}>
                            <span className="link-functional">
                                {this.state.expanded ? (<Translate id="Report.Hide" />) : (<Translate id="Report.Detail" />)}
                            </span>
                        </div>
                    </td>
                </tr>
                <Collapse isOpen={this.state.expanded} tag="tr" className={classnames("colorize", { "collapsed": !this.state.expanded })}>
                    <td colSpan="2"><b><Translate id="Report.GeneralAssemblies.MainTopics" /></b></td>
                    <td colSpan="5" className="pre-wrap">{this.props.data.mainTopics}</td>
                </Collapse>
                <Collapse isOpen={this.state.expanded} tag="tr" className={classnames("colorize", { "collapsed": !this.state.expanded })}>
                    <td colSpan="2"><b><Translate id="Report.GeneralAssemblies.PresentationWay" /></b></td>
                    <td colSpan="5" className="pre-wrap">{this.props.data.presentationWay}</td>
                </Collapse>
            </>
        )
    }

    onDetailClick = () => {
        window.innerWidth <= 768 ? this.openPopup() : this.setState({ expanded: !this.state.expanded });
    }

    openPopup() {
        this.props.showPopup("generalAssemblyItemPopup", {
            open: true,
            close: () => this.props.hidePopup(),
            data: this.props.data
        });
    }
}

export default withLocalize(connect(null, dispatch => bindActionCreators(Object.assign(popupActions), dispatch))(GeneralAssemblyItem));
